'use client';

import {
  useNebulyPageEffectiveNow,
  type NebulyPageEffectiveNow,
} from '@/domains/pages/hooks/use-nebuly-page-effective-now';
import { useNebulyPageStableNow } from '@/domains/pages/hooks/use-nebuly-page-stable-now';

/** @deprecated Use useNebulyPageStableNow */
export const useAiProficiencyStableNow = useNebulyPageStableNow;

export type AiProficiencyEffectiveNow = NebulyPageEffectiveNow;

/** @deprecated Use useNebulyPageEffectiveNow */
export const useAiProficiencyEffectiveNow = useNebulyPageEffectiveNow;
